function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.40615 18.4479L5.18871 11.4774H3.60399V18.4479H0V0.552094H6.8756C8.9716 0.552094 10.5691 1.0591 11.6681 2.07311C12.7671 3.08712 13.3167 4.42202 13.3167 6.07781C13.3167 7.42992 12.9376 8.56218 12.1794 9.4746C11.4212 10.387 10.3264 10.9953 8.89487 11.2996L13.3934 18.4479H9.40615ZM3.60399 9.01826H6.56867C8.63021 9.01826 9.66124 8.11417 9.66178 6.30599C9.66178 5.44464 9.41032 4.77295 8.90739 4.29094C8.40446 3.80892 7.62488 3.56805 6.56867 3.56832H3.60399V9.01826Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2463 0.552094V18.4479H15.6423V0.552094H19.2463Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6848 0.552094V3.39094H29.7004V18.4479H26.0956V3.39094H21.1379V0.552094H34.6848Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.567 14.8484H40.3336L39.0554 18.4479H35.2471L41.8929 0.754059H46.0077L52.6289 18.4479H48.8202L47.567 14.8484ZM46.5978 12.1361L43.9396 4.58261L41.2806 12.1361H46.5978Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M58.0718 0.552094V18.4479H54.4678V0.552094H58.0718Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M64.8454 15.7102H70.9032V18.4479H61.2415V0.552094H64.8454V15.7102Z",
  fill: "white"
});

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 19,
    viewBox: "0 0 71 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo_1.bc48c6d5.svg";
export { ForwardRef as ReactComponent };